import { ContextHolder, FronteggContext } from '@frontegg/rest-api'

/* Read the access token straight from Frontegg each time. Frontegg refreshes it in the
 * background, so any copy kept elsewhere goes stale and gets rejected. */
export const getAccessToken = (): string | null => {
  try {
    return FronteggContext.getAccessToken()
  } catch {
    return null
  }
}

/* When the session has genuinely expired, send the user back to sign in rather than leaving
 * them on a page that silently keeps failing. */
export const routeToLoginOnDeadSession = (): void => {
  try {
    const baseUrl = (ContextHolder.getContext().baseUrl as string)?.replace(/\/+$/, '')
    if (baseUrl) {
      window.location.href = `${baseUrl}/oauth/logout?post_logout_redirect_uri=${window.location}`
    }
  } catch (e) {
    console.error(e)
  }
}
